var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29154 9.1667C2.29154 5.36974 5.36959 2.2917 9.16654 2.2917C12.9635 2.2917 16.0415 5.36974 16.0415 9.1667C16.0415 12.9637 12.9635 16.0417 9.16654 16.0417C5.36959 16.0417 2.29154 12.9637 2.29154 9.1667ZM9.16654 1.0417C4.67923 1.0417 1.04154 4.67938 1.04154 9.1667C1.04154 13.654 4.67923 17.2917 9.16654 17.2917C11.1852 17.2917 13.032 16.5555 14.4529 15.337L17.0579 17.942C17.302 18.1861 17.6977 18.1861 17.9418 17.942C18.1859 17.6979 18.1859 17.3022 17.9418 17.0581L15.3368 14.4531C16.5554 13.0321 17.2915 11.1854 17.2915 9.1667C17.2915 4.67938 13.6539 1.0417 9.16654 1.0417Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4767f0ac5f640dba86a7cd2f39e341b0.svg";
export { ForwardRef as ReactComponent };